var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.styleColor === 'theme')?_c('ScrollWallTheme',{attrs:{"desc":_vm.desc,"list":_vm.list,"theme-color":_vm.themeColor}}):_vm._e(),(_vm.styleColor === 'default')?_c('ScrollWallDefault',{attrs:{"desc":_vm.desc,"list":_vm.list,"theme-color":_vm.themeColor}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }